import { h as o } from "vue";
import { s as e } from "./svgIconFactory-Dn0WJdb3.js";
o(
  "svg",
  { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 13.504 13.504" },
  o(
    "g",
    o(
      "g",
      {
        fill: "none",
        stroke: "#2b5dff",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "1.5"
      },
      [
        o("path", { d: "m4.301 6.809 2.45 2.451 2.451-2.451L6.751 9.26V.745" }),
        o("path", { d: "M.75 12.754h12.004" })
      ]
    )
  )
);
const d = (r, { attrs: t }) => e({
  props: r,
  svgNodeAttrs: { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 13.504 13.504" },
  childrenNodes: o(
    "g",
    o(
      "g",
      {
        fill: "none",
        stroke: t["stroke-color"] ?? "#2b5dff",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": t["stroke-width"] ?? "1.5"
      },
      [
        o("path", { d: "m4.301 6.809 2.45 2.451 2.451-2.451L6.751 9.26V.745" }),
        o("path", { d: "M.75 12.754h12.004" })
      ]
    )
  )
});
export {
  d as DownloadIcon
};
